import React, { useEffect, useState, useRef } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

const DurationPickerField = ({ onAsyncChange, onChange, onFocus, value }) => {

    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);

    const dayItems = useRef([...new Array(364)].map((_, index) => index));
    const hourItems = useRef([...new Array(24)].map((_, index) => index));

    const onDaysChange = async evt => {
        try {
            
            // prepare value for state update
            let index = Utils.attributeForKey.select(evt, 'id');
            let target = dayItems.current[index];

            // prepare duration value using new selection
            let duration = target * 24 + hours;

            // determine if an async change function should be called before updating state value
            if(typeof(onAsyncChange) === 'function') {
                await onAsyncChange(duration);
            }

            // update locate state with target value
            setDays(target);

            // prepare duration and notify subscriber of data change
            if(typeof(onChange) === 'function') {
                onChange(duration);
            }
            
        } catch(e) {
            console.error(e.message);
        }
    }

    const onHoursChange = async evt => {
        try {

            // prepare value for state update
            let index = Utils.attributeForKey.select(evt, 'id');
            let target = hourItems.current[index];

            // prepare duration value using new selection
            let duration = days * 24 + target;

            // determine if an async change function should be called before updating state value
            if(typeof(onAsyncChange) === 'function') {
                await onAsyncChange(duration);
            }

            // update locate state with target value
            setHours(target);

            // prepare duration and notify subscriber of data change
            if(typeof(onChange) === 'function') {
                onChange(duration);
            }
            
        } catch(e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        if(value) {
            let days = Math.floor(value / 24);
            let hours = value % 24;
            setDays(days);
            setHours(hours);
        }
    }, [value]);

    return (
        <div
        className={'row p-0 m-0'}
        style={{
            width: '100%'
        }}>
            <div className={'col-6 py-0 pl-0 pr-1'}>
                <select
                className={`custom-select ${window.theme}`}
                onChange={onDaysChange}
                onFocus={onFocus}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px',
                    color: days >= 0 ? Appearance.colors.text() : Appearance.colors.subText(),
                    marginRight: 8
                }}
                value={`${days} ${days === 1 ? 'day' : 'days'}`}>
                    <option disabled={true}>{'Days'}</option>
                    {dayItems.current.map((day, index) => {
                        return <option key={index} id={index}>{`${day} ${day === 1 ? 'day' : 'days'}`}</option>
                    })}
                </select>
            </div>
            <div className={'col-6 py-0 pl-1 pr-0'}>
                <select
                className={`custom-select ${window.theme}`}
                onChange={onHoursChange}
                onFocus={onFocus}
                style={{
                    background: `${Appearance.colors.textField()} url("images/custom-select-list-arrows-${window.theme === 'dark' ? 'white' : 'black'}.png") no-repeat right 0.75rem center`,
                    backgroundSize: '10px',
                    color: hours >= 0 ? Appearance.colors.text() : Appearance.colors.subText(),
                    marginRight: 8
                }}
                value={`${hours} ${hours === 1 ? 'hour' : 'hours'}`}>
                    <option disabled={true}>{'Hours'}</option>
                    {hourItems.current.map((hour, index) => {
                        return <option key={index} id={index}>{`${hour} ${hour === 1 ? 'hour' : 'hours'}`}</option>
                    })}
                </select>
            </div>
        </div>
    )
}
export default DurationPickerField;
